import { useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { MainContext } from "../contexts/MainContext";
import apiUrl from "./ApiConfig";
import RingLoaderB from "./Loader/RingLoaderB";

const ProtectedRoute = ({ element }) => {
  const { user, setUser } = useContext(MainContext);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300); // تاخیر ۵۰۰ میلی‌ثانیه‌ای

    return () => clearTimeout(timer); // پاک کردن تایمر هنگام خروج از کامپوننت
  }, []);

  if (isLoading) {
    return <RingLoaderB />; // نمایش لودینگ موقت
  }

  // <h2>در حال بررسی دسترسی...</h2>;

  if (user) {
    return element;
  } else {
    return <Navigate to={"/"} replace />;
  }
  // return user ? element: <Navigate to={'/'} replace />;
};

export default ProtectedRoute;
